<div
  #routineGroupFormModal
  class="modal fade"
  id="routineGroupFormModal"
  tabindex="-1"
  aria-labelledby="routineGroupFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="editing">
          Edición de una Rutina
        </h1>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="!editing">
          Creación de una Rutina
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="routineGroupForm" (ngSubmit)="onSubmit()">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Título"
              formControlName="name"
            />

            <label for="">Título (opcional)</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre.
            </div>
          </div>

          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="number"
              [ngClass]="{ 'is-invalid': weeks.invalid && weeks.touched }"
              placeholder="Semanas"
              formControlName="weeks"
            />

            <label for="">Semanas (obligatorio)</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese la cantidad de semanas.
            </div>
          </div>

          <select
            class="form-select"
            aria-label="Small select example"
            formControlName="userExperience"
          >
            <option
              [value]="level.level"
              *ngFor="let level of userExperienceLevels"
            >
              {{ level.name }}
            </option>
          </select>

          <button
            [disabled]="routineGroupForm.invalid"
            class="col-12 mt-3 d-grid btn-custom"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span *ngIf="editing">Editar</span>
            <span *ngIf="!editing">Crear</span>
          </button>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
